import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { formatCurrency } from '../../applications/Traffic/utils'

export interface ModelFitChartProps {
  weeklyData: Array<{ week: string; revenue: number; predicted: number }>
  currency: string
}

export function ModelFitChart({ weeklyData, currency }: ModelFitChartProps) {
  const options: Highcharts.Options = {
    chart: { type: 'line', height: 300 },
    title: { text: '' },
    xAxis: {
      categories: weeklyData.map(d => d.week),
      labels: { style: { fontSize: '11px' } }
    },
    yAxis: {
      title: { text: '' },
      labels: {
        formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          return `$${((this.value as number) / 1000).toFixed(0)}k`
        }
      }
    },
    tooltip: {
      shared: true,
      formatter: function (this: Highcharts.TooltipFormatterContextObject) {
        let s = `<b>${this.x}</b><br/>`
        this.points?.forEach(point => {
          s += `${point.series.name}: <b>${formatCurrency(point.y || 0, currency)}</b><br/>`
        })
        return s
      }
    },
    legend: { enabled: true },
    series: [
      {
        name: 'Actual Revenue',
        type: 'line',
        data: weeklyData.map(d => d.revenue),
        color: '#22c55e',
        lineWidth: 2,
        marker: { enabled: true, radius: 3 }
      },
      {
        name: 'Model Predicted',
        type: 'line',
        data: weeklyData.map(d => d.predicted),
        color: '#3b82f6',
        lineWidth: 2,
        dashStyle: 'Dash',
        marker: { enabled: false }
      }
    ],
    credits: { enabled: false },
  }

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-slate-200 tw-p-6">
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-4">
        <h3 className="tw-text-lg tw-font-semibold tw-text-slate-900">Model Fit: Actual vs Predicted</h3>
        <div className="tw-flex tw-items-center tw-gap-4 tw-text-sm">
          <div className="tw-flex tw-items-center tw-gap-2">
            <div className="tw-w-4 tw-h-0.5 tw-bg-green-500" />
            <span className="tw-text-slate-600">Actual</span>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <div className="tw-w-4 tw-h-0.5 tw-bg-blue-500 tw-border-dashed tw-border-t-2 tw-border-blue-500" />
            <span className="tw-text-slate-600">Predicted</span>
          </div>
        </div>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}
